module.exports = __webpack_public_path__ + "img/med-icando.83338a86.svg";